import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpClient.service';
import { agentApis } from '../../constants/api-constant/agent-api';

@Injectable({
    providedIn: 'root',
})
export class AgentService {

    fetchAgentDetails = new BehaviorSubject<boolean>(false);
    fetchAgentDetails$ = this.fetchAgentDetails.asObservable();

    fetchCompanyLogo = new BehaviorSubject<boolean>(false);
    fetchCompanyLogo$ = this.fetchCompanyLogo.asObservable();

    constructor(
        private http: HttpClient,
        private _httpClientService: HttpClientService
    ) {}

    getAgentDetails(id: any): Observable<any> {
        return this._httpClientService.get(
            `${agentApis.getAgentDetails}=${id}`
        );
    }

    editAgentDetails(payload: any, agentsId: string): Observable<any> {
        return this._httpClientService.put(
            `${agentApis.editAgentDetails}=${agentsId}`,
            payload
        );
    }

    editCounsellorDetails(payload: any, Id: string): Observable<any> {
        return this._httpClientService.put(
            `${agentApis.editCounsellorDetails}=${Id}`,
            payload
        );
    }

    uploadDoc(agentId: string, payload: Object) {
        return this._httpClientService.upload(
            `${agentApis.uploadDoc}=${agentId}`,
            payload
        );
    }

    getDocsList(agentId: string) {
        return this._httpClientService.get(
            `${agentApis.getDocsList}=${agentId}`
        );
    }

    forgotPassword(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.status}`, payload);
    }

    signupAgent(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.agent}`, payload);
    }

    getEditAgent(agentsId: string) {
        return this._httpClientService.get(
            `${agentApis.getEditAgent}${agentsId}`
        );
    }

    oldPassword(payload: any): Observable<any> {
        return this._httpClientService.post(
            `${agentApis.checkOldPass}`,
            payload
        );
    }

    changePassword(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.resetPass}`, payload);
    }

    updateProfilePicture(payload) {
        return this._httpClientService.upload(
            `${agentApis.updateProfilePicture}`,
            payload
        );
    }

    makeCall(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.agentMakeCall}`, payload);
    }

    getBankdetailsList(agentId: any, payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.agentBankDetails}${agentId}`, payload);
    }

    getCompanyLogo(agentId: string) {
        return this._httpClientService.get(
            `${agentApis.getDocsList}=${agentId}&type=logo`
        );
    }

    getCounsellorDetails(id: any): Observable<any> {
        return this._httpClientService.get(
            `${agentApis.getCounselorDetails}=${id}`
        );
    }

    setDefaultAccount(payload, agentId) {
        return this._httpClientService.post(
            `${agentApis.setDefaultBank}${agentId}`,
            payload
        );
    }

    getMouForAgents(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.getMouForAgents.replace(':tenantId',payload?.tenantId).replace(':agentId',payload?.agentId)}`, {});
    }

    getAgentsFine(): Observable<any> {
        return this._httpClientService.get(
            `${agentApis.getFine}`
        );
    }

    getOTPAgents(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.getOTPForAgents}`, payload);
    }
    checkOTPAgents(payload: any): Observable<any> {
        return this._httpClientService.post(`${agentApis.checkOTPAgents}`, payload);
    }
}
